import React, { useState, useMemo, useRef, useEffect } from 'react';
import '../styles/Update.css';

/* ---------- Scroll-reveal wrapper (no external libs) ---------- */
const Reveal = ({ children, className = '', delay = 0, as: Tag = 'div' }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
};

/* ---------- Inline icons ---------- */
const IconSearch = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconBook = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const IconCalendar = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const IconClose = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

/* ============ Combined Data ============ */
const allStallData = [
  // Single Stalls
  { sno: 1, name: 'AAMU PUBLICATION', stallNumber: '212', type: 'Single' },
  { sno: 2, name: 'AGASTHIAR PUBLICATIONS', stallNumber: '86', type: 'Single' },
  { sno: 3, name: 'ANANDHA NILAYAM', stallNumber: '37', type: 'Single' },
  { sno: 4, name: 'ANDHIMAZHAI', stallNumber: '143', type: 'Single' },
  { sno: 5, name: 'ANNAM PUBLISHERS', stallNumber: '38', type: 'Single' },
  { sno: 6, name: 'ARUL PATHIPPAGAM', stallNumber: '123', type: 'Single' },
  { sno: 7, name: 'ARUN PATHIPPAGAM', stallNumber: '12', type: 'Single' },
  { sno: 8, name: 'B. RATHNA NAYAKAR & SONS', stallNumber: '4', type: 'Single' },
  { sno: 9, name: 'ERODE PADAIPPALARGAL', stallNumber: '11', type: 'Single' },
  { sno: 10, name: 'EUREKA BOOKS', stallNumber: '150', type: 'Single' },
  { sno: 11, name: 'EXPRESS PUBLICATIONS ( DINAMANI )', stallNumber: '192', type: 'Single' },
  { sno: 12, name: 'GANGAARAANI PATHIPPAGAM', stallNumber: '24', type: 'Single' },
  { sno: 13, name: 'GEETHAM PUBLICATIONS', stallNumber: '215', type: 'Single' },
  { sno: 14, name: 'GIRI LAW HOUSE', stallNumber: '201', type: 'Single' },
  { sno: 15, name: 'GIRI TRADING AGENCY PVT.LTD', stallNumber: '96', type: 'Single' },
  { sno: 16, name: 'GOWRA PUTHAKA MAIYAM', stallNumber: '139', type: 'Single' },
  { sno: 17, name: 'HARISH BOOKS', stallNumber: '211', type: 'Single' },
  { sno: 18, name: 'THE HINDU', stallNumber: '135', type: 'Single' },
  { sno: 19, name: 'INTERNATIONAL INSTITUTE OF TAMIL STUDIES', stallNumber: '20', type: 'Single' },
  { sno: 20, name: 'ISLAMIC FOUNDATION TRUST', stallNumber: '151', type: 'Single' },
  { sno: 21, name: 'IYALVAAGAI PUBLICATION', stallNumber: '51', type: 'Single' },
  { sno: 22, name: 'JEEVA PATHIPPAGAM', stallNumber: '126', type: 'Single' },
  { sno: 23, name: 'KALAPPAI PATHIPPAGAM', stallNumber: '42', type: 'Single' },
  { sno: 24, name: 'KRISHNAMURTHI FOUNDATION INDIA', stallNumber: '49', type: 'Single' },
  { sno: 25, name: 'KUMARAN PATHIPPAGAM', stallNumber: '107', type: 'Single' },
  { sno: 26, name: 'KUMIZHMUNAI PATHIPPAGAM', stallNumber: '196', type: 'Single' },
  { sno: 27, name: 'KUTTI AGAYAM CHILDREN PUBLICATION', stallNumber: '122', type: 'Single' },
  { sno: 28, name: 'LKM PUBLICATION', stallNumber: '45', type: 'Single' },
  { sno: 29, name: 'MASK', stallNumber: '10', type: 'Single' },
  { sno: 30, name: 'MI VELIYEEDU', stallNumber: '77', type: 'Single' },
  { sno: 31, name: 'MINNANGADI PUBLICATIONS', stallNumber: '21', type: 'Single' },
  { sno: 32, name: 'MUNNETRA PATHIPAGAM', stallNumber: '72', type: 'Single' },
  { sno: 33, name: 'MUTHU COMICS', stallNumber: '15', type: 'Single' },
  { sno: 34, name: 'NAM PUBLICATION', stallNumber: '74', type: 'Single' },
  { sno: 35, name: 'NAN NOOL VELIYITAGAM', stallNumber: '142', type: 'Single' },
  { sno: 36, name: 'NANMOZHI PATHIPAGAM', stallNumber: '31', type: 'Single' },
  { sno: 37, name: 'NAVINA VIRUTCHAM', stallNumber: '94', type: 'Single' },
  { sno: 38, name: 'NIVETHITHA PATHIPPAGAM', stallNumber: '152', type: 'Single' },
  { sno: 39, name: 'PALANIAPPA BROTHERS', stallNumber: '149', type: 'Single' },
  { sno: 40, name: 'PANMAI VELI', stallNumber: '14', type: 'Single' },
  { sno: 41, name: 'PUDHUPUNAL', stallNumber: '56', type: 'Single' },
  { sno: 42, name: 'PUSTAKA DIGITAL MEDIA PVT. LTD', stallNumber: '172', type: 'Single' },
  { sno: 43, name: 'PUTHAGAKADAI.COM', stallNumber: '91', type: 'Single' },
  { sno: 44, name: 'RAJATHI PATHIPAGAM', stallNumber: '136', type: 'Single' },
  { sno: 45, name: 'RAJMOHAN PATHIPPAGAM', stallNumber: '110', type: 'Single' },
  { sno: 46, name: 'SAALIVAGANAN PATHIPPGAM', stallNumber: '155', type: 'Single' },
  { sno: 47, name: 'SATHYAA ENTERPRISES', stallNumber: '206', type: 'Single' },
  { sno: 48, name: 'SEER VAASAGAR VATTAM', stallNumber: '73', type: 'Single' },
  { sno: 49, name: 'SHANTI BOOKS', stallNumber: '32', type: 'Single' },
  { sno: 50, name: 'SIVAGURU PATHIPPAGAM', stallNumber: '125', type: 'Single' },
  { sno: 51, name: 'SMILE PUBLISHING INDIA PVT.LTD', stallNumber: '190', type: 'Single' },
  { sno: 52, name: 'SREE INDHU PUBLICATIONS', stallNumber: '41', type: 'Single' },
  { sno: 53, name: 'SRI PUTHAKA KALANJIYAM', stallNumber: '25', type: 'Single' },
  { sno: 54, name: 'SRI SENBAGA PATHIPPAGAM', stallNumber: '78', type: 'Single' },
  { sno: 55, name: 'SRI VIVEKANANDA SEVALAYAM', stallNumber: '50', type: 'Single' },
  { sno: 56, name: 'SWASAM', stallNumber: '3', type: 'Single' },
  { sno: 57, name: 'TAMIL UNIVERSITY', stallNumber: '95', type: 'Single' },
  { sno: 58, name: 'TAMIZHINI', stallNumber: '195', type: 'Single' },
  { sno: 59, name: 'THAMIZH CHOLAI PATHIPPAGAM', stallNumber: '13', type: 'Single' },
  { sno: 60, name: 'TICK SOFT', stallNumber: '175', type: 'Single' },
  { sno: 61, name: 'UNIVERSAL PUBLISHING', stallNumber: '85', type: 'Single' },
  { sno: 62, name: 'UYIRMMAI PATHIPPAGAM', stallNumber: '46', type: 'Single' },
  { sno: 63, name: 'VAGAM PUBLICATION', stallNumber: '71', type: 'Single' },
  { sno: 64, name: 'VAIGARAI PATHIPPAGAM', stallNumber: '111', type: 'Single' },
  { sno: 65, name: 'VALLI PUTHAGA ULAGAM', stallNumber: '90', type: 'Single' },
  { sno: 66, name: 'VAMSI BOOKS', stallNumber: '124', type: 'Single' },
  { sno: 67, name: 'VANATHI PATHIPPAKAM', stallNumber: '191', type: 'Single' },
  { sno: 68, name: 'VANAVIL PUTHAKALAYAM', stallNumber: '222', type: 'Single' },
  { sno: 69, name: 'VASAGASALAI PUBLICATIONS PVT LTD', stallNumber: '28', type: 'Single' },
  { sno: 70, name: 'VETHATHIRI PUBLICATIONS', stallNumber: '114', type: 'Single' },
  { sno: 71, name: 'VIDIYAL PATHIPPAGAM', stallNumber: '144', type: 'Single' },
  { sno: 72, name: 'YAAVARUM PUBLISHERS', stallNumber: '89', type: 'Single' },
  
  // Double Stalls
  { sno: 73, name: 'ANA BOOKS', stallNumber: '83, 84', type: 'Double' },
  { sno: 74, name: 'ANANDA VIKATAN PUBLISHERS PVT LTD', stallNumber: '101, 102', type: 'Double' },
  { sno: 75, name: 'APPLE PUBLISHING INTERNATIONAL (P) LTD', stallNumber: '140, 141', type: 'Double' },
  { sno: 76, name: 'ARIVU PATHIPPAGAM', stallNumber: '105, 106', type: 'Double' },
  { sno: 77, name: 'AROCKIYAA BOOKS', stallNumber: '182, 183', type: 'Double' },
  { sno: 78, name: 'ARUNA PUBLICATIONS', stallNumber: '131, 132', type: 'Double' },
  { sno: 79, name: 'ARUTCHELVAR Dr. N. MAHALINGAM TRANSLATION INSTITUTE', stallNumber: '207, 208', type: 'Double' },
  { sno: 80, name: 'ASIAN BOOK CENTER', stallNumber: '166, 167', type: 'Double' },
  { sno: 81, name: 'BASKAR BOOK HOUSE', stallNumber: '176, 177', type: 'Double' },
  { sno: 82, name: 'BELL CO', stallNumber: '35, 36', type: 'Double' },
  { sno: 83, name: 'BHARATH PUBLISHERS', stallNumber: '126, 187', type: 'Double' },
  { sno: 84, name: 'BHARATHI PUTHAKALAYAM', stallNumber: '204, 205', type: 'Double' },
  { sno: 85, name: 'BOOK BASKET', stallNumber: '57, 58', type: 'Double' },
  { sno: 86, name: 'BOOKS FOR CHILDREN', stallNumber: '213, 214', type: 'Double' },
  { sno: 87, name: 'CLASSIC PUBLICATIONS', stallNumber: '168, 169', type: 'Double' },
  { sno: 88, name: 'CORAL PUBLISHERS & DISTRIBUTORS', stallNumber: '115, 116', type: 'Double' },
  { sno: 89, name: 'DISCOVERY BOOK PALACE ( P ) LTD', stallNumber: '133, 134', type: 'Double' },
  { sno: 90, name: 'DREAM WAYS', stallNumber: '188, 189', type: 'Double' },
  { sno: 91, name: 'EDU BOOK DISTRIBUTORS', stallNumber: '137, 138', type: 'Double' },
  { sno: 92, name: 'EDUPRO INC', stallNumber: '153, 154', type: 'Double' },
  { sno: 93, name: 'ESWAR BOOK CENTRE', stallNumber: '193, 194', type: 'Double' },
  { sno: 94, name: 'FROZEN BOOKS', stallNumber: '66, 67', type: 'Double' },
  { sno: 95, name: 'HINDU TAMIL THISAI', stallNumber: '22, 23', type: 'Double' },
  { sno: 96, name: 'HIGGINBOTHAMS ( P ) LTD', stallNumber: '127, 128', type: 'Double' },
  { sno: 97, name: 'JAINCO PUBLISHERS', stallNumber: '162, 163', type: 'Double' },
  { sno: 98, name: 'KANNADHASAN PATHIPPAGAM', stallNumber: '33, 34', type: 'Double' },
  { sno: 99, name: 'KANNAPPAN PATHIPPAGAM', stallNumber: '197, 198', type: 'Double' },
  { sno: 100, name: 'KARPAGAM PUTHAKALAYAM', stallNumber: '103, 104', type: 'Double' },
  { sno: 101, name: 'KIZHAKKU PATHIPPAGAM', stallNumber: '199, 200', type: 'Double' },
  { sno: 102, name: 'LOTUS MULTIMEDIA', stallNumber: '216, 217', type: 'Double' },
  { sno: 103, name: 'MADHUMITHA BOOKS', stallNumber: '29, 30', type: 'Double' },
  { sno: 104, name: 'MANIVASAGAR PATHIPPAGAM', stallNumber: '52, 53', type: 'Double' },
  { sno: 105, name: 'MANOJ PUBLICATION', stallNumber: '173, 174', type: 'Double' },
  { sno: 106, name: 'MARUTHUVA PATHIPPAGAM', stallNumber: '5, 6', type: 'Double' },
  { sno: 107, name: 'MATHI NILAYAM', stallNumber: '16, 17', type: 'Double' },
  { sno: 108, name: 'MAYILAVAN PATHIPPAGAM', stallNumber: '97, 98', type: 'Double' },
  { sno: 109, name: 'MEENAKSHI BOOK SHOP', stallNumber: '160, 161', type: 'Double' },
  { sno: 110, name: 'MOTHER LAND BOOK HOUSE', stallNumber: '64, 65', type: 'Double' },
  { sno: 111, name: 'NAKKHEERAN', stallNumber: '129, 130', type: 'Double' },
  { sno: 112, name: 'NARMADHA PATHIPPAGAM', stallNumber: '112, 113', type: 'Double' },
  { sno: 113, name: 'NATIONAL BOOK TRUST', stallNumber: '170, 171', type: 'Double' },
  { sno: 114, name: 'OM SAKTHI BOOKS INTERNATIONAL', stallNumber: '18, 19', type: 'Double' },
  { sno: 115, name: 'OMNI BOOKS', stallNumber: '117, 118', type: 'Double' },
  { sno: 116, name: 'PADAM BOOK COMPANY', stallNumber: '39, 40', type: 'Double' },
  { sno: 117, name: 'PARRAGON PUBLISHING PVT LTD', stallNumber: '164, 165', type: 'Double' },
  { sno: 118, name: 'PENGUIN RANDOM HOUSE INDIA', stallNumber: '92, 93', type: 'Double' },
  { sno: 119, name: 'PRAKASH BOOKS INDIA PVT.LTD', stallNumber: '1, 2', type: 'Double' },
  { sno: 120, name: 'PUBLICATIONS DIVISION GOVT.OF.INDIA', stallNumber: '87, 88', type: 'Double' },
  { sno: 121, name: 'SAHITYA AKADEMI', stallNumber: '218, 219', type: 'Double' },
  { sno: 122, name: 'SAKTHI PUBLISHING HOUSE', stallNumber: '180, 181', type: 'Double' },
  { sno: 123, name: 'SAPNA BOOK HOUSE PVT LTD', stallNumber: '26, 27', type: 'Double' },
  { sno: 124, name: 'SHANKAR PATHIPPAGAM', stallNumber: '108, 109', type: 'Double' },
  { sno: 125, name: 'SHREE BALAJI BOOK SELLER & DISTRIBUTORS', stallNumber: '156, 157', type: 'Double' },
  { sno: 126, name: 'SIXTHSENSE PUBLICATIONS', stallNumber: '81, 82', type: 'Double' },
  { sno: 127, name: 'SPIDER BOOKS', stallNumber: '145, 146', type: 'Double' },
  { sno: 128, name: 'SRI BHARATHI PUBLICATIONS', stallNumber: '43, 44', type: 'Double' },
  { sno: 129, name: 'SRI RAMAKRISHNA MATH', stallNumber: '209, 210', type: 'Double' },
  { sno: 130, name: 'SRIRAM BOOKS', stallNumber: '79, 80', type: 'Double' },
  { sno: 131, name: 'SUCCESS BOOK SELLERS', stallNumber: '178, 179', type: 'Double' },
  { sno: 132, name: 'TAMILNADU PAADA NOOL KALAGAM', stallNumber: '147, 148', type: 'Double' },
  { sno: 133, name: 'THE PERIYAR SELF RESPECT PROPAGANDA INSTUTION', stallNumber: '158, 159', type: 'Double' },
  { sno: 134, name: 'THUMBI TANNARAM NULVELI', stallNumber: '75, 76', type: 'Double' },
  { sno: 135, name: 'TIGER BOOKS PVT LTD', stallNumber: '59, 60', type: 'Double' },
  { sno: 136, name: 'UNIVERSAL PUBLISHERS', stallNumber: '220, 221', type: 'Double' },
  { sno: 137, name: 'UPKAR PRAKASHAN', stallNumber: '47, 48', type: 'Double' },
  { sno: 138, name: 'V.O.C. NOOLAGAM', stallNumber: '54, 55', type: 'Double' },
  { sno: 139, name: 'VALLALAR BOOK SHOP', stallNumber: '223, 224', type: 'Double' },
  { sno: 140, name: 'VALLI PATHIPAGAM', stallNumber: '202, 203', type: 'Double' },
  { sno: 141, name: 'WISDOM GLOBAL SERVICE', stallNumber: '184, 185', type: 'Double' },
  { sno: 142, name: 'YEGAM PATHIPAGAM', stallNumber: '99, 100', type: 'Double' }
].sort((a, b) => a.name.localeCompare(b.name));

function Update() {
  return (
    <div className="app">
      {/* ============ HEADER ============ */}
      <header className="header">
        <div className="header-glow header-glow-1"></div>
        <div className="header-glow header-glow-2"></div>
        <div className="header-grain"></div>

        <div className="header-inner">
          <span className="header-badge">
            <IconBook />
            22ஆம் ஆண்டு &nbsp;•&nbsp; 2026
          </span>
          <h1>ஈரோடு புத்தகத் திருவிழா</h1>
          <h2>Erode Book Festival</h2>
          <p className="subtitle">
            தமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும்
            22 ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா
          </p>
          <span className="date-chip">
            <IconCalendar />
            அரங்க ஒதுக்கீடு குலுக்கல் நிகழ்வு: 21.07.2026
          </span>
        </div>
      </header>

      <div className="content">
        <Reveal as="div" className="announcement">
          <span className="announcement-icon">
            <IconBook />
          </span>
          <p>
            ஈரோடு புத்தகத் திருவிழாவில் அரங்குகள் அமைக்கும் நிறுவனங்கள் மற்றும்
            குலுக்கலின் மூலம் தேர்வு செய்யப்பட்ட அரங்க எண்கள் அடங்கிய பட்டியல்
          </p>
        </Reveal>

        <CombinedStallList data={allStallData} />
      </div>
    </div>
  );
}

const CombinedStallList = ({ data }) => {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return data;
    return data.filter(
      (item) =>
        item.name.toLowerCase().includes(q) ||
        item.stallNumber.toLowerCase().includes(q) ||
        item.type.toLowerCase().includes(q)
    );
  }, [data, query]);

  return (
    <Reveal as="div" className="combined-stall-list">
      <div className="stall-list-head">
        <div>
          <h3>அனைத்து அரங்குகளும்</h3>
          <span className="stall-list-count">{data.length} நிறுவனங்கள்</span>
        </div>
        <div className="search-box">
          <IconSearch />
          <input
            type="text"
            placeholder="தேடு... (பெயர் / எண் / வகை)"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          {query && (
            <button
              className="search-clear"
              onClick={() => setQuery('')}
              aria-label="Clear search"
            >
              <IconClose />
            </button>
          )}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state">பொருந்தும் முடிவுகள் இல்லை</div>
      ) : (
        <ul className="stall-entries">
          {filtered.map((item, index) => (
            <li className="stall-entry combined-entry" key={`${item.sno}-${item.name}`}>
              <span className="entry-sno">{item.sno}</span>
              <span className="entry-name">{item.name}</span>
              <span className="entry-stall">
                {item.type === 'Double' ? (
                  item.stallNumber.split(',').map((n, i) => (
                    <span className="stall-chip" key={i}>
                      {n.trim()}
                    </span>
                  ))
                ) : (
                  <span className="stall-chip">{item.stallNumber}</span>
                )}
              </span>
              <span className={`entry-type ${item.type.toLowerCase()}`}>
                {item.type}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Reveal>
  );
};

export default Update;